import React, {useContext} from "react"
import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";

import UserCard from "./UserCard"
import {UserContext} from "../../../context/UserContext"
import logo from "../../../../../common/src/assets/img/brand/CTbookWhite.svg"

const Drawer = () => {
  const { user } = useContext(UserContext);
  const {t} = useTranslation();
  const linkClassName = ({isActive}) => isActive ? "has-icon is-active" : "has-icon";

  let openedMenuItem = window.location.pathname.split("/")[1];

  return (
    <aside className="aside is-placed-left is-expanded">

      <div className='logo-container'>
        <img src={logo} alt="Logo"/>
      </div>

      <UserCard/>

      <div className="menu is-menu-main">
        <p className="menu-label">{t("Overview")}</p>
        <ul className="menu-list">
          <li>
            <NavLink to="/profile" className={linkClassName}>
              <span className="icon"><i className="fz fz-user"/></span>
              <span className="menu-item-label">{t('my_profile')}</span>
            </NavLink>
            <NavLink to="/request" className={linkClassName}>
               <span className="icon"><i className="fz fz-arrow-right-to-bracket"/></span>
               <span className="menu-item-label">{t('requests')}</span>
            </NavLink>
            <NavLink to="/offers" className={linkClassName}>
               <span className="icon"><i className="fz fz-handshake"/></span>
               <span className="menu-item-label">{t('offers')}</span>
            </NavLink>
            <NavLink to="/stage" className={linkClassName}>
               <span className="icon"><i className="fz fz-signs-post"/></span>
               <span className="menu-item-label">{t('stages')}</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </aside>
  )
}

export default Drawer
